import { render } from "./404.vue?vue&type=template&id=0c59c3f6&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=0c59c3f6&scoped=true&lang=css"

import exportComponent from "C:\\tapfactor-max\\tapfactor\\frontend_tapfactor\\tapfactorprofile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c59c3f6"]])

export default __exports__